import { render, staticRenderFns } from "./PersonalFilters.vue?vue&type=template&id=0dc4bc16&scoped=true&"
import script from "./PersonalFilters.vue?vue&type=script&lang=js&"
export * from "./PersonalFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc4bc16",
  null
  
)

export default component.exports